export default "__VITE_ASSET__07mWUfD$__"